export default __webpack_public_path__ + "static/media/B0007.1fdd974e.png";